import { useHistory } from 'react-router-dom';

const useNavigateAfterConfirm = () => {
  const history = useHistory();

  const navigateAfterConfirm = () => {
    history.push('/diabetes-data');
  };

  return navigateAfterConfirm;
};

export default useNavigateAfterConfirm;
